import { Pipe, PipeTransform } from "@angular/core";
import { executeQuery } from "firebase/data-connect";
import { userGetByIdRef } from "@jtms/default-connector";

@Pipe({
  name: "userDisplay",
  standalone: true,
  pure: true,
})
export class UserDisplayPipe implements PipeTransform {
  async transform(userId: string | null | undefined, display: "name" | "email" | "uid" = "uid"): Promise<string> {
    if (!userId) return "Unknown User";

    const userQuery = userGetByIdRef({
      uid: userId,
    });

    // Assuming UserService has a method to get user by ID
    const { data } = await executeQuery(userQuery);
    const user = data?.user;
    if (!user) return userId;
    switch (display) {
      case "name":
        return `${user.displayName || "Unnamed User"}`;
      case "email":
        return user.email || "No email";
      case "uid":
      default:
        return userId;
    }
  }
}
